<app-resp-popup-title>
  <mat-icon>receipt</mat-icon>
  <span i18n="@@WawiAPI_CreateOrder_DialogTitle">Create Order</span>
</app-resp-popup-title>
<app-resp-popup-content>
  <app-wawi-beleg-create-form (formCreated)="OnFormCreated($event)" [loading]="loading">
  </app-wawi-beleg-create-form>
</app-resp-popup-content>
@if (form) {
  <app-resp-popup-actions>
    <ctrl-btn-accept type="primary" [disabled]="loading || !form.valid" (click)="OnAccept()"></ctrl-btn-accept>
    <ctrl-btn-cancel (click)="OnCancel()"></ctrl-btn-cancel>
  </app-resp-popup-actions>
}